import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import mapDate from '../../../../function/mapDate';
import routes from '../../../../routing/routes';
import splitCisloLegMaterialu from '../../../../function/splitCisloLegMaterialu';
import './legislativnyMaterialListRow.scss';
import LegislativnyMaterialFilterListItem
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListItem';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';

interface Props {
  legMaterial: LegislativnyMaterialFilterListItem;
}

const LegislativnyMaterialListRow = ({
  legMaterial,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(legMaterial.cisloLp);

  const isStadiumPK = legMaterial.stadium?.hodnota === StadiumMaterialuEnum.MPK;

  function getStadiumNazov(): string {
    return isStadiumPK ? `${legMaterial.stadium.nazov} (do ${mapDate(legMaterial.datumUkonceniaPkMpk)})`
      : legMaterial.stadium.nazov;
  }

  return (
    <div className="legislativny-material-list-row">
      <Row>
        <Col width="one-third" className="legislativny-material-list-column__third">Číslo
          procesu
        </Col>
        <Col width="one-third" className="legislativny-material-list-column__third">Typ
          materiálu
        </Col>
        <Col width="one-third" className="legislativny-material-list-column__third">Začiatok
          štádia
        </Col>
      </Row>
      <Row className="row-container-leg-material-values">
        <Col width="one-third" className="legislativny-material-list-column__third">
          <Text type="span" bold>{legMaterial.cisloLp}</Text>
        </Col>
        <Col width="one-third" className="legislativny-material-list-column__third">
          <Text type="span" bold>{legMaterial.typNazov}</Text>
        </Col>
        <Col width="one-third" className="legislativny-material-list-column__third">
          <Text type="span" bold>{mapDate(legMaterial.zaciatokStadia)}</Text>
        </Col>
      </Row>
      <Row className="nazov-link-container">
        <Col width="full">
          <Link
            className="nazov-link"
            to={routes.procesy.detail.withParams(type, year, index)}
          >
            {legMaterial.nazov}
          </Link>
        </Col>
      </Row>
      <Row>
        <Col width="full">
          Štádium <Text type="span" bold>{getStadiumNazov()}</Text>
        </Col>
      </Row>
    </div>
  );
};

export default LegislativnyMaterialListRow;
